<template>
  <div class="number">
    <v-alert
      class="elevation-2 rounded-lg"
      prominent
      v-for="(condition, i) in number"
      :key="i"
    >
      <v-container>
        <v-row align="center">
          <v-col class="grow">
            <v-row align="center">
              <v-col cols="12" md="6" class="d-flex align-center">
                <v-select
                  v-model="condition.number.operation"
                  :items="operationlist"
                  label="เลือกเงื่อนไข"
                  class="mr-2"
                  solo
                  dense
                  color="#0D8EEE"
                  item-value="operation"
                  item-text="text"
                  :error="condition.errorLabel"
                  :error-messages="condition.errorLabelMsg"
                  @input="CheckNumber(i)"
                  :rules="[$store.getters.TextRule(condition.number.operation)]"
                  style="max-width: 160px"
                ></v-select>
                <div
                  v-if="
                    condition.number.operation === '><' ||
                      condition.number.operation === '<>'
                  "
                  class="d-flex"
                >
                  <v-text-field
                    v-model="condition.number.value_from"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[
                      $store.getters.ScoreRule(condition.number.value_from),
                    ]"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="condition.number.value_to"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[
                      $store.getters.ScoreRule(condition.number.value_to),
                    ]"
                  >
                  </v-text-field>
                </div>
                <div v-else>
                  <v-text-field
                    v-model="condition.number.value"
                    type="number"
                    solo
                    dense
                    label="คะแนน"
                    class="mr-2"
                    :error="condition.errorLabel"
                    :error-messages="condition.errorLabelMsg"
                    @input="CheckNumber(i)"
                    :rules="[$store.getters.ScoreRule(condition.number.value)]"
                  >
                  </v-text-field>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="d-flex align-center">
                <v-text-field
                  v-model="condition.defaultCondition.score"
                  type="number"
                  solo
                  dense
                  label="คะแนน"
                  :disabled="
                    condition.errorLabel ||
                      condition.defaultCondition.scoreInput
                  "
                  :rules="[
                    $store.getters.ScoreRule(condition.defaultCondition.score),
                  ]"
                  style="width: 30px"
                >
                  <template #prepend> คะแนน </template>
                </v-text-field>
                <v-checkbox
                  class="mt-0 mx-2"
                  v-model="condition.defaultCondition.scoreInput"
                  label="ใช้คะแนนจาก input"
                  @change="
                    SetZeroScroe(condition.defaultCondition.scoreInput, i)
                  "
                ></v-checkbox>
              </v-col>
              <v-col
                cols="12"
                class="d-flex align-center"
                v-if="!condition.hascompute"
              >
                <v-autocomplete
                  v-model="condition.defaultCondition.nextQuestionID"
                  :items="Jump"
                  label="เลือกคำถาม"
                  solo
                  dense
                  color="#0D8EEE"
                  item-text="questionLabel"
                  item-value="questionID"
                  :disabled="condition.errorLabel || condition.hascompute"
                  :rules="[
                    $store.getters.TextRule(
                      condition.defaultCondition.nextQuestionID
                    ),
                  ]"
                  style="width: 50px"
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                    maxHeight: 200,
                  }"
                >
                  <template #prepend> คำถามต่อไป </template>
                  <template v-slot:item="{ item }">
                    <v-list-item
                      @click="
                        condition.defaultCondition.nextQuestionID =
                          item.questionID
                      "
                    >
                      <v-list-item-title>
                        <v-row no-gutters align="center">
                          <span class="d-flex align-center">
                            {{ item.questionLabel }}
                          </span>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <v-radio-group
                  v-model="condition.hascompute"
                  row
                  label="คำนวณคะแนน"
                  class="d-flex"
                  :disabled="condition.errorLabel"
                >
                  <v-radio label="มี" color="info" :value="true"></v-radio>
                  <v-radio label="ไม่มี" color="info" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="shrink d-flex align-center">
            <v-btn
              color="#DE4F3B"
              icon
              v-show="Object.keys(number).length > 1"
              @click="$delete(number, i), CheckAllNumber()"
              ><v-icon>mdi-trash-can-outline </v-icon></v-btn
            >
          </v-col>
        </v-row>
        <div v-if="condition.hascompute && !condition.errorLabel">
          <div>
            <ComputeScore
              :computeCondition="condition.computeCondition"
              :Jump="Jump"
              :NextQuestion="NextQuestion"
            />
          </div>
        </div>
      </v-container>
    </v-alert>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn color="#0278ae" dark fab @click="AddCondition">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ComputeScore from "./ComputeScore";
import _ from "lodash";
export default {
  props: ["number", "Jump", "number_notmatch", "NextQuestion"],
  components: { ComputeScore },
  computed: {
    operationlist() {
      return this.$store.state.operation;
    },
  },
  methods: {
    AddCondition() {
      this.number.push({
        conditiontext: null,
        conditiontype: "number",
        number: { operation: "", value: 0, value_from: 0, value_to: 0 },
        errorLabel: false,
        errorLabelMsg: "",
        hascompute: false,
        defaultCondition: {
          nextQuestionID: this.NextQuestion.questionID,
          score: 0,
          scoreInput: false,
        },
        computeCondition: {
          match: [
            {
              nextQuestionID: this.NextQuestion.questionID,
              operation: "",
              value: 0,
              value_from: 0,
              value_to: 0,
              score: 0,
            },
          ],
          notmatch: {
            nextQuestionID: this.NextQuestion.questionID,
            score: 0,
          },
        },
      });
    },
    SetZeroScroe(check, index) {
      if (!this.number[index].defaultCondition.score) {
        if (check) {
          this.number[index].defaultCondition.score = 0;
        }
      }
    },
    CheckAllNumber() {
      this.number.map((item) => {
        item.numbertext = `${item.number.operation}|${
          item.number.operation === "><" || item.number.operation === "<>"
            ? `${item.number.value_from}|${item.number.value_to}`
            : item.number.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.number, "numbertext");
      let dup = _.filter(this.number, (x) => counts[x.numbertext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.numbertext) {
            item.errorLabel = true;
            item.errorLabelMsg =
              "เงื่อนไขตัวเลขนี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    },
    CheckNumber: _.debounce(function() {
      this.number.map((item) => {
        item.numbertext = `${item.number.operation}|${
          item.number.operation === "><" || item.number.operation === "<>"
            ? `${item.number.value_from}|${item.number.value_to}`
            : item.number.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.number, "numbertext");
      let dup = _.filter(this.number, (x) => counts[x.numbertext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.numbertext) {
            item.errorLabel = true;
            item.errorLabelMsg =
              "เงื่อนไขตัวเลขนี้มีอยู่ใน list ของคุณแล้ว";
          }
        });
      }
    }, 0),
  },
};
</script>

<style scoped>
.number >>> .v-input--radio-group--row .v-input--radio-group__input {
  flex-direction: row;
  flex-wrap: inherit;
}
</style>
